// Changelog authoring logic. Dependency-free and DOM-free so it can be
// unit-tested under bun; the changelog views stay thin renderers over it.

/** d3-community's limits, mirrored so the form can say so before a round trip. */
export const TITLE_MAX = 200;
export const BODY_MAX = 50000;

/**
 * Validate and shape the editor's fields into a request body. Trims title and
 * body (d3-community trims too, and rejects blanks). `product` is only included
 * when given — it is set on create and cannot change on edit.
 * @param {{product?: string, title: string, body: string}} draft
 * @returns {{payload: object|null, errors: string[]}}
 */
export function buildPostPayload({ product, title, body }) {
    const errors = [];
    const trimmedTitle = title.trim();
    const trimmedBody = body.trim();

    if (product !== undefined && !product) errors.push('Pick a product.');
    if (!trimmedTitle) errors.push('Title is required.');
    if (trimmedTitle.length > TITLE_MAX) {
        errors.push(`Title must be ${TITLE_MAX} characters or fewer.`);
    }
    if (!trimmedBody) errors.push('Body is required.');
    if (trimmedBody.length > BODY_MAX) {
        errors.push(`Body must be ${BODY_MAX} characters or fewer.`);
    }

    if (errors.length > 0) return { payload: null, errors };

    const payload = { title: trimmedTitle, body: trimmedBody };
    if (product !== undefined) payload.product = product;
    return { payload, errors };
}

/**
 * Whether the editor holds changes not yet saved. Title and body compare trimmed,
 * since that is what gets saved.
 * @param {{title: string, body: string}|null} saved null for a new, unsaved post
 * @param {{title: string, body: string}} draft
 */
export function isDirty(saved, draft) {
    if (!saved) return true;
    return saved.title.trim() !== draft.title.trim() || saved.body.trim() !== draft.body.trim();
}

/**
 * @param {{published: boolean}} post
 * @returns {'draft'|'published'}
 */
export function postStatus(post) {
    return post.published ? 'published' : 'draft';
}
